import { Component, OnInit } from '@angular/core';
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import { DomSanitizer } from "@angular/platform-browser";
import { MatSelectChange, MatTabChangeEvent } from '@angular/material';
import { Article , Year, Month, CategoryGroup } from './ceo-desk.model';
import { CeoDeskService } from './ceo-desk.service';
import { CommonDataService } from "@shared/services/common-data.service";
const VIEW_LIMIT = 3;
@Component({
  selector: 'app-ceo-desk',
  templateUrl: './ceo-desk.component.html',
  styleUrls: ['./ceo-desk.component.scss']
})
export class CeoDeskComponent implements OnInit {

  years :Year[] = [] ;
  
  months: Month[] = [];

  categories: string[] = [];

  selectedCategoryIndex:number = 0;

  selectedCategory: string;

  selectedYear : string = "";

  selectedMonth: string = "";

  categoryGroup = new CategoryGroup(); 

  isMobileView = false;

  searchText: string ='';

  viewLimit: number = VIEW_LIMIT;

  constructor(  
    private ceoDeskService:CeoDeskService,
    public apiService: ApiService,
    public sanitizer: DomSanitizer,
    private commonService: CommonDataService) {
  }

  ngOnInit() {
    this.readYears();
    this.readMonths();
    this.readCategories();
  }

  public readYears(){
    this.apiService.postData(Urls.getYear, {flag: '' }).subscribe(
      response => {
        if(response.status === 0){
          this.years = [{'year': 'All'}, ... response.data.yearList];
        }
      },
      error => {}
    )
  }

  public readMonths(){
    this.apiService.getData(Urls.getMonths).subscribe(
      response => {
        if(response.status === 0){
          this.months = [{'month': 'All'}, ...response.data.monthList];
        }
      },
      error => {}
    )
  }

  public globalFiterByYearMonth(change: MatSelectChange) {
   if(change.value){
    this.getCategoryData();
   }
  }

  public readCategories(){
    this.apiService.postData(Urls.getCategories, {categorySection: "ceo's desk"}).subscribe(
      response => {
        if(response.status === 0){
          this.categories = response.data.categories;
         // this.categories.sort();
          this.selectedCategory =   this.categories[0];
          this.getCategoryData();
        }
      },
      error => {}
    )

  }

  public onCategoryChange(change: MatTabChangeEvent){
    this.searchText ='';
    this.selectedCategoryIndex = change.index;
    this.selectedCategory = change.tab.textLabel;
    if( this.selectedCategory){
      this.getCategoryData();
    }
  }

  public getCategoryData() {
    if(this.isMobileView){
      return false;
    }
    this.commonService.loaderStatus.next(true);
    const obj = {
      type: this.selectedCategory,
      year: this.selectedYear === 'All' ? "" : this.selectedYear,
      month: this.selectedMonth === 'All' ? "" : this.selectedMonth,
    };

    this.apiService.postData(Urls.readArticles, obj).subscribe(
      response => {
        if(response.status === 0){
          this.groupArticles(response.data.articles || [])
        }else{
          this.categoryGroup = new CategoryGroup();
        }
        this.viewLimit = this.categoryGroup.articleRows.length > VIEW_LIMIT ? VIEW_LIMIT : this.categoryGroup.articleRows.length;
        this.commonService.loaderStatus.next(false);
      },
      error => {
        this.categoryGroup = new CategoryGroup();
        this.commonService.loaderStatus.next(false);
      }
    )
  }

  public groupArticles(articles: Article[] ){
    this.categoryGroup = new CategoryGroup();
    this.categoryGroup.group(articles)
    this.ceoDeskService.setCategoryGroup(this.categoryGroup);
  }

  public onViewMore(){
      this.viewLimit = this.categoryGroup.articleRows.length;
  }
}
